import { NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { Media } from "../../models/media";

@Component({
    selector: 'media-icon',
    templateUrl: './media-icon.component.html',
    styleUrls: ['./media-icon.component.scss'],
    imports: [NgSwitch, NgSwitchCase, NgSwitchDefault],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MediaIconComponent {
  @Input() media!: Media;
  @Input()@HostBinding('style.--size') size: string = '32px';
  @Input()@HostBinding('style.--backgroundColor') backgroundColor!: string;
}
